import React from 'react'
import styled from 'styled-components'
import Cleave from 'cleave.js/react'

const MaskedInputWrapper = styled.div`
  margin: 8px 0 8px;
`

const MaskedInput = styled(Cleave)`
  width: 100%;
  padding: 18px;
  font-size: inherit;
  border: 1px solid
    ${({ theme, error }) =>
      error ? theme?.['-ds-error-300']?.value : theme.colors.textGreyLight};
`

const renderMaskedDateInput = ({
  input,
  meta: { error, submitFailed },
  ...custom
}) => {
  const value = input.value || ''

  return (
    <MaskedInputWrapper>
      <MaskedInput
        options={{ date: true, datePattern: ['d', 'm', 'Y'] }}
        error={error && submitFailed}
        {...input}
        {...custom}
        value={value}
      />
    </MaskedInputWrapper>
  )
}

export default renderMaskedDateInput
